<template>
    <div 
        :class="`story-maker-post-creator ${cursorName}`" 
        :style="{ fontSize: fontSize + 'px' }" 
        ref="story-maker"
    >   
        <div class="lock" v-if="previewEnabled" :class="{ 'hover-sticker': hoveredStickerId }" @click="handlePreviewClick" @mousemove="handlePreviewMouseMove" @mouseleave="handlePreviewMouseLeave"></div>
        <stickerFocus
            v-if="previewEnabled && focusedSticker"
            :sticker="focusedSticker"
            :wrapper="stickerWrapperComponent"
            :files="files"
            :pageSelected="pageSelected"
            :backgroundFileId="backgroundFileId"
        />
        <div 
            class="overflow" 
            :class="{axeX:showAxe.x, axeY:showAxe.y}" 
            :style="{'--z-index-axe': showAxe.index, backgroundColor : formData.storification[this.idStorySelected].background.color}"
           
        >
            <template v-if="formData.storification[this.idStorySelected].hide">
                <alert 
                    title="Démasquer la story ?" subTitle="Si vous démasquer cette story, elle apparaîtra lors de la publication sur la page sélectionnée." 
                    :choices="[
                        {content:'Démasquer', warning: true, cb:()=>handleToggleHideStory(true)},
                    ]"
                />
            </template>
            
            <template v-else-if="showAlertDelete">              
                <template v-if="Object.keys(formData.storification).length > 1 || (pageSelected && pagesSelected.length > 1)">
                    <alert v-if="pageSelected && pagesSelected.length > 1 && saveAllFormData.main && saveAllFormData.main.storification && saveAllFormData.main.storification[this.idStorySelected]" 
                        title="Masquer la story ?" subTitle="Si vous masquez cette story, elle n’apparaîtra pas lors de la publication sur la page sélectionnée." 
                        :choices="[
                            {content:'Masquer', warning: true, cb: handleToggleHideStory},
                            {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                        ]"
                    />
                    <alert v-else="" 
                        title="Supprimer la story ?" subTitle="Si vous supprimer cette story, vous perdrez toutes les modification que vous avez apportées" 
                        :choices="[
                            {content:'Supprimer', warning: true, cb: handleDeleteStory},
                            {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                        ]"
                    />
                </template>
                <alert v-else=""
                    title="Réinitialiser la story ?" subTitle="Si vous réinitialiser cette story, vous perdrez toutes les modification que vous avez apportées" 
                    :choices="[
                        {content:'Réinitialiser', warning: true, cb: handleResetStory},
                        {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                    ]"
                />
            </template>

            <template v-if="!overlayMode && !previewEnabled">
                <div class="btns-action" data-html2canvas-ignore="true">
                    <div class="btn sound" v-if="hasStorySound" :class="{'muted':mutedSound}" @click="toggleMuteSound"></div>

                    <div class="btn highlight" @click="setOverlay('highlight')" v-if="pageSelected && pagesSelectedIncludeConciergerie">
                        <div class="container-img" v-if="idStorySelected && formData.storification[idStorySelected] && formData.storification[idStorySelected].highlight && formData.storification[idStorySelected].highlight.text" :style="{backgroundColor : formData.storification[idStorySelected].background.color}">
                           
                            <template v-if="mediaHighlights">
                                <img v-if="mediaHighlights.type.startsWith('image')" :src="mediaHighlights.url">
                                <video v-else-if="mediaHighlights.type.startsWith('video')" :src="mediaHighlights.url" :type="mediaHighlights.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="true">
                           
                                </video>
                            </template>
                        </div>
                        <img :src="require('@/assets/img/instagram/instagram_story_highlight_filled_32.png')">
                    </div>

                    <div class="btn text" @click="addText">
                        <img :src="require('@/assets/img/instagram/icon_story_text.png')">
                    </div>
                    <div class="btn stickers" @click="setOverlay('stickers')">
                        <img :src="require('@/assets/img/instagram/icon_story_sticker.png')">
                    </div>

                    <Tooltip
                        v-if="pagesSelectedIncludeConciergerie"
                        @click="() => { musicSticker ? updateSticker(musicSticker.id, {isEditing : true}) : setOverlay('stickers-musicMenu')}"
                        :active="!!musicSticker" 
                        :text="!!musicSticker &&
                            `
                            ${musicSticker.data.music.track ? musicSticker.data.music.track.display_artist : musicSticker.data.music.original_sound.ig_artist.full_name} - 
                            ${(musicSticker.data.music.track ? musicSticker.data.music.track.title : musicSticker.data.music.original_sound.title)}
                            `
                        "
                        position="bottom"
                        classCustom="btn music"
                    >
                        <img v-if="musicSticker" class="thumbnail-music" :src="musicSticker.data.music.track ? musicSticker.data.music.track.cover_artwork_thumbnail_uri : musicSticker.data.music.original_sound.ig_artist.profile_pic_url">
                        <img v-else :src="require('@/assets/img/instagram/icon_story_music.png')">
                    </Tooltip>
                  
                </div>
                
                <div class="btn delete-story" @click="handleDeleteStory" data-html2canvas-ignore="true">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>

            </template>

            <div v-else-if="!previewEnabled && overlayMode && (overlayMode.slice(0,8) == 'stickers' || overlayMode == 'backgroundResize')" class="btns-action">
                <div class="btn cancel" @click="closeOverlay">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>
            </div>

            <div class="btn-background-resize" v-if="overlayMode == 'backgroundResize' && backgroundFileId && files[backgroundFileId]">
                <template v-if="files[backgroundFileId].info.aspectRatio > 0.5625">
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(45deg);" @click="setSizeBackground('containX')"></i>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"  @click="setSizeBackground('containY')"></i>
                </template>
                <template v-else>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(135deg);" @click="setSizeBackground('containY')"></i>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"  @click="setSizeBackground('containX')"></i>
                </template>  
            </div>
            
            <div class="trash-stiker" v-if="onStickerDrag" @mouseover="trashIsHover = true" @mouseleave="trashIsHover = false" :class="{active : trashIsHover}">
                <div class="icon"></div>       
            </div>

            <div class="container-bg-story" :class="{edit:overlayMode == 'backgroundResize'}">
                <draggable 
                    :position="formData.storification[this.idStorySelected].background.position" 
                    :transform="formData.storification[this.idStorySelected].background.transform" 
                    :classCustom="formData.storification[this.idStorySelected].background.size"
                    :disableTransform="overlayMode !== 'backgroundResize'" 
                    :disableMove="overlayMode !== 'backgroundResize'" 
                    @setStoryMakerCursor="setCursor"
                    @saveFormData="() => $emit('saveFormData')"
                   
                >
                    <div class="bg-story selectDisable" :class="formData.storification[this.idStorySelected].background.size">
                        <template v-if="backgroundFileId && files[backgroundFileId]">
                            <img  v-if="files[backgroundFileId].info.type.startsWith('image/')" class="selectDisable" :src="files[backgroundFileId].url"  draggable="false">
                            <video 
                                v-else-if="files[backgroundFileId].info.type.startsWith('video/')" 
                                :src="files[backgroundFileId].url" 
                                :type="files[backgroundFileId].info.type" 
                                @timeupdate="videoCheckLoop"
                                onloadedmetadata="true"
                                preload="metadata" 
                                class="source" 
                                ref="video"
                                :muted="mutedSound || musicSticker"
                                autoplay loop playsinline
                            ></video>
                        </template>  
                    </div>
                </draggable>

            </div>
          
            <template v-if="overlayMode !== 'backgroundResize'" v-for="sticker in renderedStickers"  >
                <draggable
                    :key="sticker.id"
                    :position="sticker.position" 
                    :transform="sticker.transform" 
                    :disableTransform="sticker.disableTransform" 
                    :disableMove="sticker.disableMove" 
                    :disableDelete="sticker.disableDelete"
                    :disableIncreaseZIndex="sticker.disableIncreaseZIndex" 
                    :zIndex="sticker.zIndex"
                    :trashIsHover="trashIsHover"
                    :classCustom="`story-maker-draggable-sticker ${sticker.type} id-${sticker.id}`"
                    @setDragState="(state)=>{onStickerDrag = state; trashIsHover = false}"
                    @setStoryMakerCursor="setCursor"
                    @increaseZIndex="()=>increaseZIndexSticker(sticker.id)"
                    @deleteSticker="()=>deleteSticker(sticker.id)"
                    @saveFormData="() => $emit('saveFormData')"
                    @setShowAxe="setShowAxe"
                >
                    <template v-slot="{ setCover, setCbClick, isPreventCover , isCover }">
                        <stickerWrapper
                            :sticker="sticker"
                            :isPreventCover="isPreventCover"
                            :isCover="isCover"
                            :setCover="setCover"
                            :setCbClick="setCbClick"
                            :files="files"
                            :previewEnabled="previewEnabled"
                            :pageSelected="pageSelected"
                            :backgroundFileId="backgroundFileId"
                            :mutedSound="mutedSound || !!musicSticker"
                            @updateSticker="updateSticker"
                            @deleteSticker="deleteSticker"
                        />
                    </template>
                </draggable>
            </template>

            <StickerMenu 
                v-if="overlayMode && overlayMode.split('-')[0] == 'stickers'" 
                :menuNameDefault="overlayMode.split('-')[1]" 
                :initialSearch="overlayData"
                :dataInstagramDefault="dataInstagramDefault" 
                :stickers="Object.values(formData.storification[this.idStorySelected].stickers)"
                :pagesSelectedIncludeConciergerie="pagesSelectedIncludeConciergerie"
                @addSticker="addSticker" 
                @updateSticker="updateSticker" 
                @close="closeOverlay"
            />
            <HighlightMenu 
                v-else-if="overlayMode && overlayMode == 'highlight'" 
                :story="formData.storification[this.idStorySelected]"
                :highlights="highlightsPage[pageSelected.id] ? highlightsPage[pageSelected.id] : null" 
                :files="files"
                @updateHighlight="updateHighlight" 
                @close="closeOverlay"
            />
        </div>



         <audio 
            v-if="musicSticker" 
            @loadedmetadata="setStartMusic"
            @timeupdate="checkTimeMusic"
            :src="(musicSticker.data.music.track || musicSticker.data.music.original_sound).fast_start_progressive_download_url" 
            autoplay
            loop
            @canplaythrough="(e) => e.target.volume = mutedSound ? '0' : '0.5'"
            ref="audio"
            >
        </audio>

        <div 
            v-if="
                previewEnabled &&
                hasStorySound
            " 
            :key="mutedSound ? 'no-sound' : 'sound'" 
            :class="mutedSound ? 'no-sound' : 'sound'"
        ></div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import StickerMenu from './storyMaker/stickerMenu/main.vue';
    import HighlightMenu from './storyMaker/highlightMenu.vue'
    import draggable from './storyMaker/draggable.vue';
    import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
    import { stickerDataDefault } from './storyMaker/stickerMenu/main.vue';
    import minxinPost from '@/components/mixins/Posts.vue'
    import mixinBot from '@/components/mixins/Bots.vue'
    import alert from './storyMaker/alert.vue';
    import { findStickerAtPoint, getStickerTargetUrl, FOCUSABLE_STICKER_TYPES } from './storyMaker/stickerTargetUrl.js';
    import stickerFocus from './storyMaker/stickerFocus.vue';
    import previewStickerTooltip from './storyMaker/previewStickerTooltip.js';
    import { formDataDefault } from './../../constante.js';
    import { allInstagramNative } from './../../utils.js';
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'

    export default {

        mixins: [minxinPost, mixinBot, previewStickerTooltip],
        components: {
            StickerMenu,
            HighlightMenu,
            draggable,
            stickerWrapper,  
            alert,
            Tooltip,
            stickerFocus
        },

        props: {
            formData :  Object,
            saveAllFormData :  Object,
            idStorySelected: {
                type: String,
                default: '0'
            },
            pageSelected: {
                type: Object,
                default: false
            },

            previewEnabled: {
                type: Boolean,
                default: false
            },
            deleteStory: Function,
            toggleHideStory: Function,
            files:Object,
        },

        data() {
            return {
                zIndex: {
                    gif:  Math.max(5000,...Object.values(this.formData.storification[this.idStorySelected].stickers).map(s => s.zIndex)) + 1,
                    other:  Math.max(10,...Object.values(this.formData.storification[this.idStorySelected].stickers).map(s => s.type == 'gif' ? 0 : s.zIndex)) + 1,
                },
              
                overlayMode: false,
                overlayData: null,
                cursorName: '',
                onStickerDrag: false,
                trashIsHover: false,
                showAxe: {
                    y:false,
                    x:false,
                    index: -1
                },
                showAlertDelete : false,
                resizeObserver: null,
                fontSize: 0,
                highlightsPage: {},
                mutedSound: true,
                focusedSticker: null,
            }
        },

        mounted () {

            if (!this.previewEnabled) this.getDataInstagramDefault();
            EventBus.$on('storyMaker-setOverlay', this.setOverlay);

            this.resizeObserver = new ResizeObserver(() => {
                this.updateFontSize();
            });
            this.resizeObserver.observe(this.$refs['story-maker']);
            this.updateFontSize();
        },

        methods: {
            handleDeleteStory() {
                if (!this.showAlertDelete) {
                    this.showAlertDelete = true
                    return
                }
                this.deleteStory()
                this.showAlertDelete = false
            },
            handleResetStory() {
                this.$set(this.formData.storification, this.idStorySelected , JSON.parse(JSON.stringify(formDataDefault.storification[0])))
                this.showAlertDelete = false
                this.$emit('saveFormData')
            },
            handleToggleHideStory(force = false) {
                if (!this.showAlertDelete && !force) {
                    this.showAlertDelete = true
                    return
                }
                this.toggleHideStory()
                this.showAlertDelete = false
            },
            addSticker(sticker) {
             
                if (!sticker.id) sticker.id = Date.now()
                if (!sticker.zIndex) {
                    if (sticker.type == 'post') sticker.zIndex = 9
                    else if (sticker.type == 'gif') sticker.zIndex = ++this.zIndex.gif
                    else sticker.zIndex = ++this.zIndex.other
                }
              
                //Empecher les doublons de certain stickers
                const typeStickersUnique = {localisation: 'delete', music: 'delete', survey: 'edit', slider: 'edit', link: 'delete', hashtag: 'edit', product: 'delete'}

                if (typeStickersUnique[sticker.type]) {
                    const stickerFind =  Object.values(this.formData.storification[this.idStorySelected].stickers).find(s => s.type == sticker.type)
                    if (stickerFind) {
                        if (typeStickersUnique[sticker.type] == 'delete') {
                            this.$delete(this.formData.storification[this.idStorySelected].stickers, stickerFind.id)
                        }else{
                            sticker = {...stickerFind, isEditing:true}
                        }
                    }
                }

                // Remove the music_missing placeholder when a real music sticker is added
                if (sticker.type === 'music') {
                    const missingSticker = Object.values(this.formData.storification[this.idStorySelected].stickers).find(s => s.type === 'music_missing')
                    if (missingSticker) {
                        this.$delete(this.formData.storification[this.idStorySelected].stickers, missingSticker.id)
                    }
                }

                this.$set(this.formData.storification[this.idStorySelected].stickers, sticker.id, sticker)
                this.$emit('saveFormData')
            },

            updateSticker(id, payload) {
                this.$set(this.formData.storification[this.idStorySelected].stickers, id, {
                    ...this.formData.storification[this.idStorySelected].stickers[id],
                    ...payload
                })
                this.$emit('saveFormData')
            },

            updateHighlight(payload) {
                this.$set(this.formData.storification[this.idStorySelected], 'highlight', {
                    ...this.formData.storification[this.idStorySelected].highlight,
                    ...payload
                })
                this.$emit('saveFormData')
            },

            deleteSticker(id) {
                this.$delete(this.formData.storification[this.idStorySelected].stickers, id)
                this.$emit('saveFormData')         
            },

            increaseZIndexSticker(id) {
                console.log("increaseZIndexSticker")
                const sticker = this.formData.storification[this.idStorySelected].stickers[id]

                if (sticker.type == 'post') return

                let zIndex;
                if (sticker.type == 'gif') {
                    if (sticker.zIndex == this.zIndex.gif) return
                    zIndex = ++this.zIndex.gif 
                }else{
                    if (sticker.zIndex == this.zIndex.other) return
                    zIndex = ++this.zIndex.other 
                }
               
                this.$set(this.formData.storification[this.idStorySelected].stickers, id, {
                    ...this.formData.storification[this.idStorySelected].stickers[id],
                    zIndex: zIndex
                })
                this.$emit('saveFormData')
            },

            setCursor(cursorName) {
                this.cursorName = cursorName
            },

            setShowAxe(axe, bool) {
                this.$set(this.showAxe, axe, bool)
            },

            setOverlay(name, data) {
                this.overlayMode = name
                this.overlayData = data || null
                if (name == 'highlight') {
                    this.loadHighlights(this.pageSelected.id)
                }
            },

            closeOverlay() { 
                this.overlayMode = false
                this.overlayData = null
            },

            async getDataInstagramDefault() {
                let page = this.pagesSelected.find(p => p.story_config && p.story_config.created && p.network == 'instagram')
                
                const data = {}

                if (page) {
                    //GIF
                   
                    if (!this.dataInstagramDefault.gifs.length) {
                        try {
                            const gifsResponse = (await this.getTrendGifsInstagram(page.id)).body.gifs.results.giphy
                            if (Array.isArray(gifsResponse) && gifsResponse.length) data.gifs = gifsResponse
                            console.log("getDataInstagramDefault", data.gifs)
                        } catch (error) {
                            console.log("getDataInstagramDefault error", error)
                        }
                    }
                    
                    //music
                    if (!this.dataInstagramDefault.musics.forYou.length || !this.dataInstagramDefault.musics.topTrends.length) {
                        data.musics = this.dataInstagramDefault.musics;
                        try {
                            if (!this.dataInstagramDefault.musics.forYou.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id)).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.forYou = musicsReponse
                            }
                            if (!this.dataInstagramDefault.musics.topTrends.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id, "topTrends")).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.topTrends = musicsReponse
                            }
                        } catch (error) {
                        }
                    }

                    //localisation 
                    if (!this.dataInstagramDefault.localisations.length) {
                        try {
                            const localisationsResponse = (await this.getLocation(page.id, 'france')).body.locations
                            if (Array.isArray(localisationsResponse) && localisationsResponse.length) data.localisations = localisationsResponse
                        } catch (error) {
                        }
                    }

                    //shops
                    if (!this.dataInstagramDefault.shops.length) {
                        try {
                            const shopsResponse = (await this.getTrendShopsInstagram(page.id)).body.shops
                            if (Array.isArray(shopsResponse) && shopsResponse.length) data.shops = shopsResponse
                        } catch (error) {
                        }
                    }

                    this.$store.commit('postCreator/updateDataStoryMakerDefault', data);
                } 
            },
            
            addText() {
                this.addSticker({...JSON.parse(JSON.stringify(stickerDataDefault['text']))})
            },

            setSizeBackground(size) {

                this.$set(
                    this.formData.storification[this.idStorySelected], 
                    'background', 
                    {   
                        ...this.formData.storification[this.idStorySelected].background,
                        size : size,
                        position: {"x":50,"y":50},
                        transform: {"rotate":0,"scale":1}
                    }
                ) 
                this.$emit('saveFormData')

            },

            updateFontSize() {
                console.log('updateFontSize',this.$refs['story-maker'], this.$refs['story-maker'].offsetWidth)
                const phoneWidth = this.$refs['story-maker'].offsetWidth;
                this.fontSize = phoneWidth;
            },

            async loadHighlights(pageId) {
                if (!this.previewEnabled && pageId && !this.highlightsPage[pageId]) {
                    const {data} = await this.getHighlightsInstagram({id: pageId})
                    this.$set(this.highlightsPage, pageId, data && data.highlights ? data.highlights : [])
                }
            },

            toggleMuteSound() {
                this.mutedSound = !this.mutedSound;
                const audio = this.$refs.audio;
                if (audio) {
                    audio.volume = this.mutedSound ? 0 : 0.5;
                }
            },

            handlePreviewClick(e) {
                this.hidePreviewTooltip();
                if (this.focusedSticker) {
                    this.focusedSticker = null;
                    return;
                }
                // Le calque .lock masque les stickers : on cherche le sticker sous le curseur
                const hit = findStickerAtPoint(this.$el, this.renderedStickers, e.clientX, e.clientY);
                if (hit) {
                    const url = getStickerTargetUrl(hit.sticker, this.previewNetwork, hit.element);
                    if (url) {
                        window.open(url, '_blank', 'noopener');
                        return;
                    }
                    if (FOCUSABLE_STICKER_TYPES.includes(hit.sticker.type)) {
                        this.focusedSticker = hit.sticker;
                        return;
                    }
                }
                this.toggleMuteSound();
            },

            setMuteSound(bool) {
                this.mutedSound = bool;
                const audio = this.$refs.audio;
                if (audio) {
                    audio.volume = this.mutedSound ? 0 : 0.5;
                }
            },


            videoCheckLoop(e) {
                //s'assurer que la musique boucle en même temps que la vidéo
                if (e.target.currentTime <= 0.2) {
                    this.restartMusic()
                }

                if (e.target.currentTime >= 60) {
                    e.target.currentTime = 0
                }
            },

            setStartMusic(e) {
                //positionner la musique au bon endroit
                const audio = e ? e.target : this.$refs.audio;
                if (this.musicSticker && audio) {
                    const currentTimeVideo = this.$refs.video ? this.$refs.video.currentTime : 0;
                    const startTime = this.musicSticker.data.start/1000 + currentTimeVideo;
                    if (Number.isFinite(startTime)) audio.currentTime = startTime;
                }
            },

            restartMusic(e) {
                //positionner la musique au bon endroit
                const audio = e ? e.target : this.$refs.audio;
                if (this.musicSticker && audio) {
                    const startTime = this.musicSticker.data.start/1000;
                    if (Number.isFinite(startTime)) audio.currentTime = startTime;
                }
            },

            checkTimeMusic(e) {
                //s'assurer que la musique boucle bien sur le bon segment
                if (e.target && this.musicSticker) {
                    if (e.target.currentTime < this.musicSticker.data.start/1000) {
                        this.restartMusic()
                    }

                    if (this.musicSticker.data.rangeDuration) {
                        const endTime = (this.musicSticker.data.start + this.musicSticker.data.rangeDuration)/1000;
                        if (!this.$refs.video && e.target.currentTime >= endTime) {
                            this.restartMusic()
                        }
                    }
                }
            }
            
        },

        watch: {
            idStorySelected() {
                this.focusedSticker = null;
            },
            ['pageSelected.id']: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.loadHighlights(this.pageSelected.id)
                }
            },
        },

        computed: {

            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            dataInstagramDefault() {
                return this.$store.getters['postCreator/dataStoryMakerDefault'];
            },
            stickerWrapperComponent() {
                return stickerWrapper;
            },

            previewStickers() {
                return this.renderedStickers;
            },

            previewNetwork() {
                return this.pageSelected && this.pageSelected.network === 'facebook' ? 'facebook' : 'instagram';
            },

            // Reel/vidéo repartagé en sticker post : son activable via le bouton son
            hasVideoPostSticker() {
                return this.renderedStickers.some(sticker => {
                    if (sticker.type !== 'post' || !sticker.data) return false;
                    if (sticker.data.fileType) return sticker.data.type === 'video';
                    const file = sticker.data.idFile && this.files[sticker.data.idFile];
                    return !!(file && file.info.type2 === 'video');
                });
            },

            hasStorySound() {
                return !!this.musicSticker
                    || !!(this.backgroundFileId && this.files[this.backgroundFileId] && this.files[this.backgroundFileId].info.type.startsWith('video/'))
                    || this.hasVideoPostSticker;
            },

            musicSticker() {
                // Cherche directement le premier sticker de type 'music'
                return Object.values(this.formData.storification[this.idStorySelected].stickers).find(sticker => sticker.type === 'music') || null;
            },

            renderedStickers() {
                const stickers = Object.values(this.formData.storification[this.idStorySelected].stickers);
                if (this.pageSelected && this.pageSelected.network === 'facebook') {
                    return stickers.filter(sticker => sticker.type !== 'music');
                }
                return stickers;
            },

            backgroundFileId() {
                if (this.idStorySelected && Object.values(this.formData.storification[this.idStorySelected].stickers).some(s => s.type === 'post')) return null
                return this.idStorySelected && this.formData.storification[this.idStorySelected].background.file ? this.formData.storification[this.idStorySelected].background.file.id : null
            },

            mediaHighlights() {

                if (this.pageSelected && this.idStorySelected && this.formData && this.formData.storification[this.idStorySelected] && this.formData.storification[this.idStorySelected].highlight) {
                    if (this.formData.storification[this.idStorySelected].highlight.id) {
                        if (this.highlightsPage[this.pageSelected.id]) {
                            const highlight = this.highlightsPage[this.pageSelected.id].find(h => h.id == this.formData.storification[this.idStorySelected].highlight.id)
                            if (highlight) {
                                
                                return {
                                    type : 'image',
                                    url: highlight.img
                                }
                            }
                        }
                    
                    }else if (this.formData.storification[this.idStorySelected].highlight.text) {
                        if (this.formData.storification[this.idStorySelected].background.file && this.formData.storification[this.idStorySelected].background.file.id && this.files[this.formData.storification[this.idStorySelected].background.file.id]) {
                            return {
                                type : this.files[this.formData.storification[this.idStorySelected].background.file.id].info.type,
                                url: this.files[this.formData.storification[this.idStorySelected].background.file.id].url
                            }
                        }
                    }
                }
                return ''
                //highlightsPage[pageSelected.id]
            },

            pagesSelectedIncludeConciergerie() {
                return allInstagramNative(this.pagesSelected)
            },
         
            
          
            
        },

        beforeDestroy () {
            EventBus.$off('storyMaker-setOverlay', this.setOverlay);
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



